/**
 *
 */

(function(window, undefined) {
  'use strict';
  var Route = function($stateProvider, $urlRouterProvider) {
    var onEnter = [
      'CblMessageSrvc',
      function(messaggiSrvc) {
        messaggiSrvc.reset();
      }
    ];

    $stateProvider
      .state('tlps-proposta', {
        url: '/propostaProdottiTelepass/:ndg/:idProdotto/:idPratica',
        template: '<tlps-proposta ' + 'class="wrapper"></tlps-proposta>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Proposta Prodotti Telepass',
          parent: 'schedaCliente'
        }
      })
      .state('tlps-configurazione-soglie', {
        url: '/configurazioneSoglieTelepass/',
        template:
          '<configurazione-soglie ' +
          'class="wrapper"></configurazione-soglie>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Configurazione Soglie',
          parent: 'home'
        }
      })
      .state('tlps-visualizzazione-apparati', {
        url: '/visualizzazioneApparatiTelepass/',
        template:
          '<visualizzazione-apparati ' +
          'class="wrapper"></visualizzazione-apparati>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Visualizzazione Apparati',
          parent: 'home'
        }
      })
      .state('tlps-presa-carico', {
        url: '/presaInCaricoTelepass/',
        template: '<presa-in-carico ' + 'class="wrapper"></presa-in-carico>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Presa in Carico Apparati',
          parent: 'home'
        }
      })
      .state('tlps-post-vendita', {
        url: '/postVenditaTelepass/:ndg/:idPratica',
        template: '<tlps-post-vendita class="wrapper"></tlps-post-vendita>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Telepass',
          parent: 'schedaCliente'
        }
      })
      .state('tlps-post-vendita-trasloco', {
        url: '/postVenditaTelepassTrasloco/:ndg/:idPratica',
        template:
          '<tlps-trasloco-telepass class="wrapper"></tlps-trasloco-telepass>',
        onEnter: onEnter,
        ncyBreadcrumb: {
          label: 'Post Vendita Telepass',
          parent: 'schedaCliente'
        }
      });
  };

  Route.$inject = ['$stateProvider', '$urlRouterProvider'];

  angular.module('cbl.telepass.wa').config(Route);
})(window);



//////////////////
// WEBPACK FOOTER
// ./app/app.route.js
// module id = 2
// module chunks = 0